import { useLingui } from '@lingui/react/macro';

export class NotFoundError extends Error {}

export const isNotFoundError = (error: unknown): error is NotFoundError => {
  return error instanceof NotFoundError;
};

/** Surface a missing resource to the surrounding error boundary during render. */
export const useThrowIfNotFound = (isNotFound: boolean) => {
  const { t } = useLingui();
  if (isNotFound) throw new NotFoundError(t`Not found`);
};
